export const environment = {
  production: false,
  env: 'development',
  API_URL: 'https://api.dev.datastorio.cloud',
  KEYCLOAK_URL: 'https://auth.dev.datastorio.cloud',
  FRONTEND_URL: 'https://portal.dev.datastor.io',
  REGISTRATION_URL: 'https://registration.dev.datastor.io',
  ZENDESK_ACCOUNT_URL: 'kelyntech.zendesk.com'
};
